/**
 * 👖 BOTTOMS
 *
 * Leg armor equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: STR for heavy armor, DEX for light armor
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 */

export const BOTTOMS = {
  // ============================================================
  // COMMON BOTTOMS (2) - Lv 10, 15
  // ============================================================
  clothPants: {
    id: 'clothPants',
    name: 'Cloth Pants',
    icon: '👖',
    slot: 'bottom',
    rarity: 'common',
    levelReq: 10,
    requirements: { DEX: 8 },
    description: 'Simple cloth pants, comfortable but not protective.',
    stats: {
      defense: 1,
      health: 8,
    },
  },
  leatherTrousers: {
    id: 'leatherTrousers',
    name: 'Leather Trousers',
    icon: '👖',
    slot: 'bottom',
    rarity: 'common',
    levelReq: 15,
    requirements: { STR: 15 },
    description: 'Tough leather trousers for basic protection.',
    stats: {
      defense: 2,
      health: 10,
    },
  },

  // ============================================================
  // UNCOMMON BOTTOMS (2) - Lv 25, 30
  // ============================================================
  chainLeggings: {
    id: 'chainLeggings',
    name: 'Chain Leggings',
    icon: '⛓️',
    slot: 'bottom',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { STR: 40 },
    description: 'Leggings reinforced with metal chains.',
    stats: {
      defense: 4,
      health: 20,
    },
  },
  studdedPants: {
    id: 'studdedPants',
    name: 'Studded Pants',
    icon: '👖',
    slot: 'bottom',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { STR: 35, DEX: 20 },
    description: 'Leather pants with metal studs.',
    stats: {
      defense: 3,
      health: 25,
    },
  },

  // ============================================================
  // RARE BOTTOMS (2) - Lv 40, 45
  // ============================================================
  plateLeggings: {
    id: 'plateLeggings',
    name: 'Plate Leggings',
    icon: '🦵',
    slot: 'bottom',
    rarity: 'rare',
    levelReq: 40,
    requirements: { STR: 75 },
    description: 'Heavy plate leg armor.',
    stats: {
      defense: 7,
      health: 40,
    },
  },
  dragonScaleLeggings: {
    id: 'dragonScaleLeggings',
    name: 'Dragon Scale Leggings',
    icon: '🐉',
    slot: 'bottom',
    rarity: 'rare',
    levelReq: 45,
    requirements: { STR: 65, DEX: 35 },
    description: 'Leggings crafted from dragon scales.',
    stats: {
      defense: 6,
      health: 45,
    },
  },

  // ============================================================
  // EPIC BOTTOMS (2) - Lv 55, 60
  // ============================================================
  titanLeggings: {
    id: 'titanLeggings',
    name: 'Titan Leggings',
    icon: '⚜️',
    slot: 'bottom',
    rarity: 'epic',
    levelReq: 55,
    requirements: { STR: 115 },
    description: 'Leg armor forged by titans.',
    stats: {
      defense: 12,
      health: 80,
    },
  },
  abyssalGreaves: {
    id: 'abyssalGreaves',
    name: 'Abyssal Greaves',
    icon: '🌑',
    slot: 'bottom',
    rarity: 'epic',
    levelReq: 60,
    requirements: { STR: 90, INT: 50 },
    description: 'Dark greaves that absorb damage.',
    stats: {
      defense: 10,
      health: 90,
      speed: 1,
    },
  },

  // ============================================================
  // LEGENDARY BOTTOMS (2) - Lv 75, 85
  // ============================================================
  eternityPants: {
    id: 'eternityPants',
    name: 'Eternity Pants',
    icon: '✨',
    slot: 'bottom',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { STR: 150 },
    description: 'Leg armor that transcends time itself.',
    stats: {
      defense: 18,
      health: 140,
    },
  },
  voidTrousers: {
    id: 'voidTrousers',
    name: 'Void Trousers',
    icon: '🌌',
    slot: 'bottom',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { STR: 120, DEX: 80 },
    description: 'Woven from the fabric between dimensions.',
    stats: {
      defense: 15,
      health: 160,
      evasion: 0.03,
    },
  },
};
